import React from "react";
import { useNavigate, Link, useSearchParams, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import {
    globalLoader,
    handleServerValidations,
} from "../../../../utils/commonfunction";
import { forgetPassword } from "../../services/auth.services";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import CustomError from "../../../../utils/customError";
import { useValidationSchemas } from "../../validator/validation"
import logowide from '../../../../assets/center/images/logo-h.png'
import { DoctorForgetPassword } from "../../../doctor/services/auth.services";

const CenterForgotPwdPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { forgetPasswordValidationSchema } = useValidationSchemas()
    const [searchParams] = useSearchParams();
    const location = useLocation();

    const formik = useFormik({
        initialValues: { email: "" },
        validationSchema: forgetPasswordValidationSchema,
        onSubmit: (values, { resetForm }) => {
            globalLoader(true);
            const formData = new FormData();
            formData.append("email", values.email.toLowerCase());
            formData.append("role", location?.state?.select_role);
            if (location?.state?.select_role == 'center') {
                forgetPassword(formData)
                    .then((response) => {
                        globalLoader(false)
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            resetForm();
                            navigate("/center/otp-verification", {
                                state: {
                                    select_role: location?.state?.select_role,
                                    email: values.email
                                }
                            });
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        globalLoader(false);
                        console.log("error--->", error)
                    });
            } else {
                DoctorForgetPassword(formData)
                    .then((response) => {
                        globalLoader(false)
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            resetForm();
                            navigate("/doctor/otp-verification", {
                                state: {
                                    select_role: location?.state?.select_role,
                                    email: values.email
                                }
                            });
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        globalLoader(false);
                        console.log("error--->", error)
                    });
            }
        }
    });

    return (

        <div className="auth-body d-flex align-items-center justify-content-center">
            <div className="auth-box">
                <div className="form-box-inner d-flex flex-column gap-5">
                    <div className="form-logo">
                        <img src={logowide} />
                    </div>
                    <div className="form-card">
                        <div className="form-text">
                            <h5 className="mt-2">{t("center.forget_password.heading")}</h5>
                            <p>{t("center.forget_password.description")}</p>
                        </div>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="form-group mb-3">
                                <label htmlFor="email" className="form-label">{t("center.forget_password.login_label_email")}<span>*</span></label>
                                <input type="text" className="form-control" id="email" name="email"
                                    placeholder={t("center.forget_password.login_placeholder_email")} value={formik?.values?.email} onChange={formik.handleChange} onBlur={formik.handleBlur} />
                                <span className="text-danger d-flex text-left">
                                    <CustomError name="email" form={formik} />
                                </span>
                            </div>
                            <button type="submit" className={"btn btn-primary w-100"}>
                                {t("center.forget_password.btn_submit")}
                            </button>
                        </form>
                    </div>
                    <div className="d-flex justify-content-center">
                        <div className="back-text  d-flex gap-2 align-items-center">
                            <i className="ti ti-arrow-left"></i>
                            <Link
                                className="link-text"
                                to={`/${location?.state?.select_role}/login`}
                                state={{ select_role: location?.state?.select_role }}
                            >
                                Back to Login
                            </Link>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CenterForgotPwdPage;
